/* eslint-disable */
import saveStoreDraft from "../../utils/saveStoreDraft";
import useStoreFormDraft from "../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import { doc } from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import apicache from "../../components/clearCach/clear";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import {
  Search,
  PlusCircle,
  Truck,
  Save,
  X,
  CheckCircle,
  ChevronDown,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import DhdStatesPricing from "../../components/deliveryPrice/dhd";
import ZrStatesPricing from "../../components/deliveryPrice/zrExpress";
import NoestStatesPricing from "../../components/deliveryPrice/noest";
import Modal from "react-modal";
import { Plus, Trash2, Building2, DollarSign } from "lucide-react";

function Delivery() {
  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const MySwal = withReactContent(Swal);
  const [showSideBar, setShowSideBar] = useState(true);
  const [data, setData] = useStoreFormDraft(store);
  const [addedState, setAddedState] = useState("");
  const [addedCode, setAddedCode] = useState("");
  const [addedstopdesk, setAddedstopdesk] = useState("");
  const [addedpricestopdesk, setAddedpricestopdesk] = useState("");
  const [addedhide, setAddedhide] = useState(false);
  const products = useSelector((state) => state.ProductsReducer);
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const [isEditing, setIsEditing] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  // Modal Controls
  const [openConfirm, setOpenConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState(""); // "DHD" or "ZR"
  const openConfirmModal = (type) => {
    setConfirmType(type);
    setOpenConfirm(true);
  };

  Modal.setAppElement("#root");

  // ✅ دالة تحويل stopdesk/stopdesks القديم للجديد
  const normalizeStopdesk = (wilaya) => {
    // ✅ أولا نشوفو stopdesks (الجديد)
    if (Array.isArray(wilaya?.stopdesks) && wilaya.stopdesks.length > 0) {
      return wilaya.stopdesks.map((x) => ({
        name: x?.name ?? "",
        price: x?.price ?? "",
      }));
    }

    // ✅ ثانيا نشوفو stopdesk القديم
    const stopdesk = wilaya?.stopdesk;

    if (Array.isArray(stopdesk)) {
      if (stopdesk.length === 0) return [{ name: "", price: "" }];

      // ancien format: ["Yalidine", "ZrExpress"]
      if (typeof stopdesk[0] === "string") {
        return stopdesk.map((n) => ({ name: n || "", price: "" }));
      }

      // nouveau format
      return stopdesk.map((x) => ({
        name: x?.name ?? "",
        price: x?.price ?? "",
      }));
    }

    // ancien format: "24 شارع إبن خلدون" (adresse)
    if (typeof stopdesk === "string" && stopdesk.trim()) {
      return [{ name: stopdesk.trim(), price: "" }];
    }

    return [{ name: "", price: "" }];
  };

  const [isStopdeskModalOpen, setIsStopdeskModalOpen] = useState(false);

  // draft modal
  const [stopdeskUsePricesDraft, setStopdeskUsePricesDraft] = useState(false);
  const [stopdeskDraft, setStopdeskDraft] = useState([{ name: "", price: "" }]);
  const [selectedWilaya, setSelectedWilaya] = useState(null);
  const [stopdeskGlobalPriceDraft, setStopdeskGlobalPriceDraft] = useState("");

  const openStopdeskModal = (wilaya_code) => {
    setIsEditing(true);
    const st = data?.delevery?.states?.find(
      (s) => s.wilaya_code === wilaya_code
    );
    setSelectedWilaya(wilaya_code);

    setStopdeskUsePricesDraft(!!st?.stopdeskUsePrices);
    const defaultPrice = String(st?.price ?? "");
    setStopdeskGlobalPriceDraft(String(st?.pricestopdesk ?? st?.price ?? ""));

    // ✅ نمرر الولاية كاملة باش normalizeStopdesk يشوف stopdesks و stopdesk
    setStopdeskDraft(
      normalizeStopdesk(st).map((r) => ({
        ...r,
        price: r.price !== "" && r.price !== undefined ? r.price : defaultPrice,
      }))
    );

    setIsStopdeskModalOpen(true);
  };

  const closeStopdeskModal = () => {
    setIsStopdeskModalOpen(false);
    setSelectedWilaya(null);
  };

  const addStopdeskRow = () => {
    setStopdeskDraft((prev) => [
      ...prev,
      {
        name: "",
        price: stopdeskUsePricesDraft
          ? ""
          : String(stopdeskGlobalPriceDraft ?? ""),
      },
    ]);
  };

  const removeStopdeskRow = (idx) => {
    setStopdeskDraft((prev) => {
      const next = prev.filter((_, i) => i !== idx);
      return next.length ? next : [{ name: "", price: "" }];
    });
  };

  const updateStopdeskRow = (idx, key, value) => {
    setStopdeskDraft((prev) =>
      prev.map((row, i) => (i === idx ? { ...row, [key]: value } : row))
    );
  };

  const saveStopdeskModal = async () => {
    setIsEditing(true);

    // ✅ validation simple quand global OFF
    if (
      !stopdeskUsePricesDraft &&
      String(stopdeskGlobalPriceDraft).trim() === ""
    ) {
      Swal.fire({ icon: "warning", title: t("ui.globalPriceRequired") });
      return;
    }

    // 1) update local data + build payload
    let payload;
    const buildPayload = (prev) => {
      const newArr = prev?.delevery?.states?.map((s) => {
        if (s.wilaya_code !== selectedWilaya) return s;

        const globalPriceNum = parseInt(stopdeskGlobalPriceDraft, 10);

        const cleaned = stopdeskDraft
          .map((x) => ({
            name: (x.name || "").trim(),
            price: stopdeskUsePricesDraft
              ? parseInt(x.price, 10) || globalPriceNum // ✅ NUMBER
              : globalPriceNum, // ✅ NUMBER
          }))
          .filter((x) => x.name.length > 0);

        const firstStopdesk = cleaned.length > 0 ? cleaned[0].name : "";

        return {
          ...s,
          stopdeskUsePrices: stopdeskUsePricesDraft,
          pricestopdesk: stopdeskUsePricesDraft
            ? s.pricestopdesk ?? globalPriceNum
            : globalPriceNum,
          stopdesk: firstStopdesk, // ✅ نحدثو stopdesk القديم
          stopdesks: cleaned.length
            ? cleaned
            : [{ name: "", price: globalPriceNum }],
        };
      });

      payload = {
        ...prev,
        delevery: { ...prev.delevery, states: newArr },
      };

      return payload;
    };
    payload = buildPayload(data);
    setData(payload);

    try {
      const safePayload = payload;
      console.log("SENDING TO FIRESTORE:", safePayload?.delevery?.states?.[0]);

      await saveStoreDraft(doc(db, "store", safePayload.id), store, safePayload);

      Swal.fire({
        icon: "success",
        title: t("servicePageActivation.cashBack.cashBackActivation.alerts.success.saved.title"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });

      setIsEditing(false);
      closeStopdeskModal();
    } catch (err) {
      console.error("FIRESTORE ERROR:", err);
      Swal.fire({ icon: "error", title: t("ui.firestoreError") });
    }
  };

  const handleConfirmApply = () => {
    if (confirmType === "DHD") {
      setData({
        ...data,
        delevery: { ...data.delevery, states: DhdStatesPricing },
      });
    }

    if (confirmType === "ZR") {
      setData({
        ...data,
        delevery: { ...data.delevery, states: ZrStatesPricing },
      });
    }

    if (confirmType === "NOEST") {
      setData({
        ...data,
        delevery: { ...data.delevery, states: NoestStatesPricing },
      });
    }

    setOpenConfirm(false);
  };

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".dropdown-container")) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!stopdeskUsePricesDraft) {
      setStopdeskDraft((prev) =>
        prev.map((r) => ({
          ...r,
          price: String(stopdeskGlobalPriceDraft ?? ""),
        }))
      );
    }
  }, [stopdeskGlobalPriceDraft, stopdeskUsePricesDraft]);

  const updateFieldChanged = (index, e) => {
    setIsEditing(true);
    if (store.country === "الجزائر") {
      const fieldName = e.target.name;
      let newArr = data.delevery.states.map((state) => {
        if (state.wilaya_code === index) {
          switch (fieldName) {
            case "price":
              return { ...state, price: parseInt(e.target.value) };
            case "hide":
              return { ...state, hide: !state.hide };
            case "stopdesk":
              return { ...state, stopdesk: e.target.value || null };
            case "hidestopdesk":
              return { ...state, hidestopdesk: !state.hidestopdesk };
            case "pricestopdesk":
              return { ...state, pricestopdesk: parseInt(e.target.value) };
            default:
              return state;
          }
        } else {
          return state;
        }
      });

      setData({ ...data, delevery: { ...data.delevery, states: newArr } });
    } else {
      let newArr;
      if (e.target.name === "price") {
        newArr = [
          ...data?.delevery?.states2.map((state) =>
            state.wilaya_code === index
              ? { ...state, price: parseInt(e.target.value) }
              : { ...state }
          ),
        ];
      }
      if (e.target.name === "hide") {
        newArr = [
          ...data?.delevery?.states2.map((state) =>
            state.wilaya_code === index
              ? { ...state, hide: !state.hide }
              : { ...state }
          ),
        ];
      }
      if (e.target.name === "stopdesk") {
        newArr = [
          ...data?.delevery?.states2.map((state) =>
            state.wilaya_code === index
              ? { ...state, stopdesk: e.target.value }
              : { ...state }
          ),
        ];
      }
      if (e.target.name === "hidestopdesk") {
        newArr = [
          ...data?.delevery?.states2.map((state) =>
            state.wilaya_code === index
              ? { ...state, hidestopdesk: !state.hidestopdesk }
              : { ...state }
          ),
        ];
      }
      if (e.target.name === "pricestopdesk") {
        newArr = [
          ...data?.delevery?.states2.map((state) =>
            state.wilaya_code === index
              ? { ...state, pricestopdesk: parseInt(e.target.value) }
              : { ...state }
          ),
        ];
      }

      setData({ ...data, delevery: { ...data.delevery, states2: newArr } });
    }
  };

  const message = (e) => {
    e.preventDefault();
    MySwal.fire({
      title: (
        <a href="https://m.me/F0orweb" target="_blank" rel="noreferrer">
          {t("footerSettings.swal_contact_link")}
        </a>
      ),
      isDismissed: true,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    apicache(account, products);

    try {
      const payload = data;
      console.log("SENDING TO FIRESTORE:", payload?.delevery?.states?.[0]);

      await saveStoreDraft(doc(db, "store", payload.id), store, payload); // ✅ merge

      setIsEditing(false);
      Swal.fire({
        icon: "success",
        title: t("footerSettings.swal_success_title"),
        confirmButtonText: t("footerSettings.swal_success_confirm"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    } catch (err) {
      console.error("FIRESTORE ERROR:", err);
      Swal.fire({ icon: "error", title: t("ui.firestoreError") });
    }
  };

  const handleSubmit2 = async (e) => {
    e.preventDefault();
    setData({
      ...data,
      delevery: {
        ...data.delevery,
        states2: !!data?.delevery?.states2
          ? [
            ...data?.delevery?.states2,
            {
              name: addedState,
              price: "0",
              hide: addedhide,
              wilaya_code: addedCode,
              stopdesk: addedstopdesk,
              hidestopdesk: true,
              pricestopdesk: addedpricestopdesk,
            },
          ]
          : [
            {
              name: addedState,
              price: "0",
              hide: addedhide,
              wilaya_code: addedCode,
              stopdesk: addedstopdesk,
              hidestopdesk: true,
              pricestopdesk: addedpricestopdesk,
            },
          ],
      },
    });
    setAddedCode("");
    setAddedState("");
    setShowModal(false);
    setIsEditing(false);
  };

  const handleImportCSV = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (event) => {
      const csv = event.target.result;
      const lines = csv.split("\n");

      const headers = lines[0].split(",").map((h) => h.trim());

      const importedStates = lines
        .slice(1)
        .filter((line) => line.trim() !== "")
        .map((line) => {
          const values = line.split(",");
          return {
            wilaya_code: values[0],
            name: values[1],
            price: parseInt(values[2]),
            hide: values[3] === "true",
            stopdesk: values[4] || "",
            hidestopdesk: values[5] === "true",
            pricestopdesk: parseInt(values[6]),
          };
        });

      setData({
        ...data,
        delevery: {
          ...data.delevery,
          states: importedStates,
        },
      });

      Swal.fire({
        icon: "success",
        title: t("ui.ratesImported"),
      });
    };

    reader.readAsText(file);
  };

  const exportCSV = () => {
    const states = data.delevery.states;

    const header =
      "wilaya_code,name,price,hide,stopdesk,hidestopdesk,pricestopdesk\n";

    const rows = states
      .map(
        (s) =>
          `${s.wilaya_code},${s.name},${s.price},${s.hide},${s.stopdesk || ""
          },${s.hidestopdesk},${s.pricestopdesk}`
      )
      .join("\n");

    const csvContent = header + rows;

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "delivery_prices.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setShowDropdown(false);
  };

  return (
    <div
      className="container-fluid bg-purple-50 dark:!bg-[#141414] min-h-screen"
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 w-full dark:!bg-[#141414]"
          style={{ flex: 1, backgroundColor: "#fbf8fc" }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] dark:!text-[#9e68ba] mb-0">
                  {t("delevery.page_title")}
                </h2>
                <p className="text-gray-600 dark:!text-gray-300 mb-0">
                  {t("delevery.page_subtitle")}
                </p>
              </div>

              {/* Dropdown Menu */}
              <div className="relative dropdown-container">
                <button
                  onClick={() => setShowDropdown(!showDropdown)}
                  className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-[#9b59bf] hover:bg-[#814a9f] text-white font-medium transition-colors shadow-sm"
                >
                  <span>{t("delevery.actions")}</span>
                  <ChevronDown
                    size={18}
                    className={`transition-transform ${showDropdown ? "rotate-180" : ""
                      }`}
                  />
                </button>

                {showDropdown && (
                  <div className="absolute left-0 mt-2 w-56 bg-white dark:!bg-[#181819] rounded-lg shadow-lg border border-gray-200 dark:!border-[#3c3a3d] py-1 z-50">
                    {/* Export Option */}

                    <button
                      onClick={() => openConfirmModal("DHD")}
                      className="w-full flex items-center gap-3 px-4 py-2.5 hover:bg-purple-50 dark:hover:!bg-[#141414] transition-colors text-right"
                    >
                      <div className="w-8 h-8 rounded-lg bg-purple-100 dark:bg-[#141414] flex items-center justify-center">
                        <img
                          src="/dhd-icons.png"
                          alt={t("ui.dhdIcon")}
                          className="w-5 h-5 object-contain"
                        />
                      </div>

                      <span className="text-sm font-medium text-gray-800 dark:!text-gray-300">
                        {t("ui.dhdRates")}
                      </span>
                    </button>

                    <button
                      onClick={() => openConfirmModal("ZR")}
                      className="w-full flex items-center gap-3 px-4 py-2.5 hover:bg-purple-50 dark:hover:!bg-[#141414] transition-colors text-right"
                    >
                      <div className="w-8 h-8 rounded-lg bg-purple-100 dark:bg-[#141414] flex items-center justify-center">
                        <img
                          src="/zr-icons.png"
                          alt={t("ui.zrIcon")}
                          className="w-5 h-5 object-contain"
                        />
                      </div>
                      <span className="text-sm font-medium text-gray-800 dark:!text-gray-300">
                        {t("ui.zrRates")}
                      </span>
                    </button>
                    <button
                      onClick={() => openConfirmModal("NOEST")}
                      className="w-full flex items-center gap-3 px-4 py-2.5 hover:bg-purple-50 dark:hover:!bg-[#141414] transition-colors text-right"
                    >
                      <div className="w-8 h-8 rounded-lg bg-purple-100 dark:bg-[#141414] flex items-center justify-center">
                        <img
                          src="/noest-icon.png"
                          alt={t("ui.noestIcon")}
                          className="w-5 h-5 object-contain"
                        />
                      </div>
                      <span className="text-sm font-medium text-gray-800 dark:!text-gray-300">
                        {t("ui.noestRates")}
                      </span>
                    </button>
                    <div className="h-px bg-gray-200 dark:!bg-[#3c3a3d] my-1"></div>

                    {/* Import Option */}
                    <button
                      onClick={() => {
                        document.getElementById("importCSV").click();
                        setShowDropdown(false);
                      }}
                      className="w-full flex items-center gap-3 px-4 py-2.5 hover:bg-purple-50 dark:hover:!bg-[#141414] transition-colors text-right"
                    >
                      <div className="w-8 h-8 rounded-lg bg-[#faf1ff] dark:bg-[#141414] flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#9e68ba"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                          <polyline points="7 10 12 15 17 10" />
                          <line x1="12" y1="15" x2="12" y2="3" />
                        </svg>
                      </div>
                      <span className="text-sm font-medium text-gray-800 dark:!text-gray-300">
                        {t("delevery.import") || t("ui.importCsv")}
                      </span>
                    </button>

                    <button
                      onClick={exportCSV}
                      className="w-full flex items-center gap-3 px-4 py-2.5 hover:bg-purple-50 dark:hover:!bg-[#141414] transition-colors text-right"
                    >
                      <div className="w-8 h-8 rounded-lg bg-[#faf1ff] dark:bg-[#141414] flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#9e68ba"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                          <polyline points="17 8 12 3 7 8" />
                          <line x1="12" y1="3" x2="12" y2="15" />
                        </svg>
                      </div>
                      <span className="text-sm font-medium text-gray-800 dark:!text-gray-300">
                        {t("delevery.export") || t("ui.exportCsv")}
                      </span>
                    </button>
                  </div>
                )}

                <input
                  type="file"
                  id="importCSV"
                  accept=".csv"
                  className="hidden"
                  onChange={handleImportCSV}
                />
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="m-3 p-0">
            {data && (
              <div className="my-3">
                <div className="row">
                  {store.country === "الجزائر" ? (
                    <form onSubmit={!!account.store ? handleSubmit : message}>
                      <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-2 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                        {/* Free Delivery Option */}
                        <div className="flex items-center gap-2 mb-4 p-2 bg-[#fcf6ff] dark:!bg-[#141414] rounded-lg">
                          <input
                            type="checkbox"
                            className="w-4 h-4 text-[#9e68ba] bg-gray-100 dark:!bg-[#3c3a3d] border-gray-300 dark:!border-[#3c3a3d] rounded focus:ring-purple-200"
                            checked={data?.delevery?.free}
                            onChange={() =>
                              setData({
                                ...data,
                                delevery: {
                                  ...data.delevery,
                                  free: !data?.delevery?.free,
                                  paid: data?.delevery?.free,
                                },
                              })
                            }
                          />
                          <span className="text-[#9e68ba] dark:!text-[#9e68ba] font-medium">
                            {t("delevery.free_delivery")}
                          </span>
                          <Truck
                            size={18}
                            className="text-[#9e68ba] dark:!text-[#9e68ba] mr-1"
                          />
                        </div>

                        {/* States Section */}
                        <div className="bg-white dark:!bg-[#181819] rounded-lg shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-4">
                          {/* Search States */}
                          <div className="p-3 border-b border-[#fbf4ff] dark:!border-[#3c3a3d] flex justify-center">
                            <div className="relative w-full max-w-lg">
                              <input
                                type="text"
                                className="w-full pr-10 pl-4 py-2 rounded-lg border border-gray-300 dark:!border-[#3c3a3d] dark:!bg-[#141414] dark:!text-gray-200 focus:outline-none focus:ring-2 focus:ring-purple-200 focus:border-transparent"
                                placeholder={t("delevery.search_placeholder")}
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                              />
                              <Search
                                size={18}
                                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 dark:!text-gray-300"
                              />
                            </div>
                          </div>

                          {/* States Grid */}
                          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 p-4">
                            {data.delevery.states
                              .filter(
                                (state) =>
                                  state.name
                                    .toLowerCase()
                                    .includes(filter.toLowerCase()) ||
                                  state.wilaya_code
                                    .toLowerCase()
                                    .includes(filter.toLowerCase())
                              )
                              .map((state) => (
                                <div
                                  key={state.wilaya_code}
                                  className="bg-white dark:!bg-[#141414] rounded-lg shadow-sm border border-gray-200 dark:!border-[#3c3a3d] hover:border-purple-200 dark:hover:border-purple-400 transition p-3"
                                >
                                  {/* State Info */}
                                  <div className="flex items-center justify-between mb-2 pb-2 border-b border-gray-100 dark:!border-[#3c3a3d]">
                                    <div className="flex items-center gap-2">
                                      <input
                                        type="checkbox"
                                        name="hide"
                                        className="w-4 h-4 text-[#9e68ba] bg-gray-100 dark:!bg-[#3c3a3d] border-gray-300 dark:!border-[#3c3a3d]"
                                        checked={state.hide}
                                        onChange={(e) =>
                                          updateFieldChanged(
                                            state.wilaya_code,
                                            e
                                          )
                                        }
                                      />
                                      <span className="font-medium text-gray-800 dark:!text-gray-200">
                                        {state.name}{" "}
                                        <span className="text-xs text-gray-500 dark:!text-gray-400">
                                          ({state.wilaya_code})
                                        </span>
                                      </span>
                                    </div>
                                  </div>

                                  {/* Price Input */}
                                  <div className="mb-3">
                                    <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300 mb-1">
                                      {t("delevery.delivery_price")}
                                    </label>
                                    <input
                                      type="number"
                                      name="price"
                                      className="w-full p-2 border border-gray-300 dark:!border-[#3c3a3d] dark:!bg-[#181819] dark:!text-gray-200 rounded-md focus:ring-purple-200 focus:border-purple-500"
                                      value={state.price}
                                      onChange={(e) =>
                                        updateFieldChanged(state.wilaya_code, e)
                                      }
                                    />
                                  </div>

                                  {/* Stopdesk Section */}
                                  <div className="bg-gray-50 dark:!bg-[#181819] p-3 rounded-md">
                                    <div className="flex items-center gap-2 mb-3">
                                      <input
                                        type="checkbox"
                                        name="hidestopdesk"
                                        className="w-4 h-4 text-[#9e68ba] bg-gray-100 dark:!bg-[#3c3a3d] border-gray-300 dark:!border-[#3c3a3d]"
                                        checked={state.hidestopdesk}
                                        onChange={(e) =>
                                          updateFieldChanged(
                                            state.wilaya_code,
                                            e
                                          )
                                        }
                                      />
                                      <span className="text-sm font-medium text-gray-700 dark:!text-gray-300">
                                        {t("delevery.pickup_option")}
                                      </span>
                                    </div>

                                    {/* Bouton amélioré */}
                                    <div className="w-full">
                                      <button
                                        type="button"
                                        onClick={() =>
                                          openStopdeskModal(state.wilaya_code)
                                        }
                                        className="w-full py-2 px-4 rounded-lg bg-[#9e68ba] hover:bg-[#984ac0] text-white font-medium flex items-center justify-center gap-2 shadow-md hover:shadow-lg transition-all duration-200"
                                      >
                                        <Building2 size={18} />
                                        <span className="truncate">
                                          {t("delevery.manage_stopdesk") ||
                                            t("delevery.manage_stopdesk")}
                                        </span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>

                        {/* Save Button */}
                        <div className="flex justify-center">
                          <button
                            type="submit"
                            className="py-2 px-6 rounded-lg bg-[#9b59bf] hover:bg-[#814a9f] text-white font-medium flex items-center gap-2 transition-colors shadow-sm"
                          >
                            <Save size={18} />
                            {t("delevery.save_changes")}
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className="bg-white rounded-xl shadow-sm p-4 m-2 border border-[#fbf4ff]">
                      {/* Free Delivery Option */}
                      <div className="flex items-center gap-2 mb-4 p-2 bg-[#fcf6ff] rounded-lg">
                        <input
                          type="checkbox"
                          className="w-4 h-4 text-[#9e68ba] bg-gray-100 border-gray-300 rounded focus:ring-purple-200"
                          onChange={() =>
                            setData({
                              ...data,
                              delevery: {
                                ...data.delevery,
                                free: !data?.delevery?.free,
                                paid: data?.delevery?.free,
                              },
                            })
                          }
                        />
                        <span className="text-[#9e68ba] font-medium">
                          {t("delevery.free_delivery")}
                        </span>
                        <Truck size={18} className="text-[#9e68ba] mr-1" />
                      </div>

                      {/* States Section */}
                      <div className="bg-white rounded-lg shadow-sm border border-[#fbf4ff] mb-4">
                        {/* Search and Add States */}
                        <div className="p-3 border-b border-[#fbf4ff] flex flex-wrap justify-center items-center gap-3">
                          <div className="relative flex-grow max-w-md">
                            <input
                              type="text"
                              className="w-full pr-10 pl-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-purple-200 focus:border-transparent"
                              placeholder={t("delevery.search_placeholder")}
                              value={filter}
                              onChange={(e) => setFilter(e.target.value)}
                            />
                            <Search
                              size={18}
                              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                            />
                          </div>
                          <button
                            type="button"
                            onClick={() => setShowModal(true)}
                            className="flex items-center gap-1 py-2 px-4 bg-[#9b59bf] hover:bg-[#814a9f] text-white rounded-lg shadow-sm transition-colors"
                          >
                            <PlusCircle size={18} />
                            {t("delevery.add_state")}
                          </button>
                        </div>

                        {/* States Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 p-4">
                          {!!data?.delevery?.states2 &&
                            data?.delevery?.states2
                              .filter(
                                (state) =>
                                  state.name
                                    .toLowerCase()
                                    .includes(filter.toLowerCase()) ||
                                  state.wilaya_code
                                    .toLowerCase()
                                    .includes(filter.toLowerCase())
                              )
                              .map((state) => (
                                <div
                                  key={state.wilaya_code}
                                  className="bg-white rounded-lg shadow-sm border border-gray-200 hover:border-purple-200 transition p-3"
                                >
                                  {/* State Info */}
                                  <div className="flex items-center justify-between mb-2 pb-2 border-b border-gray-100">
                                    <div className="flex items-center gap-2">
                                      <input
                                        type="checkbox"
                                        name="hide"
                                        className="w-4 h-4 text-[#9e68ba]"
                                        checked={state.hide}
                                        onChange={(e) =>
                                          updateFieldChanged(
                                            state.wilaya_code,
                                            e
                                          )
                                        }
                                      />
                                      <span className="font-medium text-gray-800">
                                        {state.name}{" "}
                                        <span className="text-xs text-gray-500">
                                          ({state.wilaya_code})
                                        </span>
                                      </span>
                                    </div>
                                  </div>

                                  {/* Price Input */}
                                  <div className="mb-3">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                      {t("delevery.delivery_price")}
                                    </label>
                                    <input
                                      type="number"
                                      name="price"
                                      className="w-full p-2 border border-gray-300 rounded-md focus:ring-purple-200 focus:border-purple-500"
                                      value={state.price}
                                      onChange={(e) =>
                                        updateFieldChanged(state.wilaya_code, e)
                                      }
                                    />
                                  </div>

                                  {/* Stopdesk Section */}
                                  <div className="bg-gray-50 p-2 rounded-md">
                                    <div className="flex items-center gap-2 mb-2">
                                      <input
                                        type="checkbox"
                                        name="hidestopdesk"
                                        className="w-4 h-4 text-[#9e68ba]"
                                        checked={state.hidestopdesk}
                                        onChange={(e) =>
                                          updateFieldChanged(
                                            state.wilaya_code,
                                            e
                                          )
                                        }
                                      />
                                      <span className="text-sm font-medium text-gray-700">
                                        {t("delevery.pickup_option")}
                                      </span>
                                    </div>
                                    <div className="grid grid-cols-2 gap-2">
                                      <div>
                                        <input
                                          type="text"
                                          name="stopdesk"
                                          placeholder={t(
                                            "delevery.pickup_office"
                                          )}
                                          className="w-full p-2 border border-gray-300 rounded-md text-sm"
                                          value={state.stopdesk || ""}
                                          onChange={(e) =>
                                            updateFieldChanged(
                                              state.wilaya_code,
                                              e
                                            )
                                          }
                                        />
                                      </div>
                                      <div>
                                        <input
                                          type="number"
                                          name="pricestopdesk"
                                          placeholder={t(
                                            "delevery.pickup_price"
                                          )}
                                          className="w-full p-2 border border-gray-300 rounded-md text-sm"
                                          value={state.pricestopdesk || ""}
                                          onChange={(e) =>
                                            updateFieldChanged(
                                              state.wilaya_code,
                                              e
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                        </div>
                      </div>

                      {/* Save Button */}
                      <div className="flex justify-center">
                        <button
                          type="button"
                          onClick={handleSubmit}
                          className="py-2 px-6 rounded-lg bg-[#9b59bf] hover:bg-[#814a9f] text-white font-medium flex items-center gap-2 transition-colors shadow-sm"
                        >
                          <Save size={18} />
                          {t("delevery.save_changes")}
                        </button>
                      </div>

                      {/* Add State Modal */}
                      {showModal && (
                        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                          <div className="bg-white rounded-lg shadow-lg w-full max-w-md mx-4">
                            <div className="flex items-center justify-between p-4 border-b border-gray-200">
                              <h3 className="text-lg font-semibold text-[#9e68ba]">
                                {t("delevery.add_state")}
                              </h3>
                              <button
                                onClick={() => setShowModal(false)}
                                className="text-gray-500 hover:text-gray-700"
                              >
                                <X size={20} />
                              </button>
                            </div>
                            <form onSubmit={handleSubmit2}>
                              <div className="p-4 space-y-4">
                                <div>
                                  <label className="block text-sm font-medium text-gray-700 mb-1">
                                    {t("delevery.modal.name_label")}
                                  </label>
                                  <input
                                    type="text"
                                    placeholder={t("name")}
                                    className="w-full p-2 border border-gray-300 rounded-md focus:ring-purple-200 focus:border-purple-500"
                                    value={addedState}
                                    onChange={(e) =>
                                      setAddedState(e.target.value)
                                    }
                                    required
                                  />
                                </div>
                                <div>
                                  <label className="block text-sm font-medium text-gray-700 mb-1">
                                    {t("delevery.modal.code_label")}
                                  </label>
                                  <input
                                    type="text"
                                    placeholder={t("sku")}
                                    className="w-full p-2 border border-gray-300 rounded-md focus:ring-purple-200 focus:border-purple-500"
                                    value={addedCode}
                                    onChange={(e) =>
                                      setAddedCode(e.target.value)
                                    }
                                    required
                                  />
                                </div>
                                <div className="bg-gray-50 p-3 rounded-md">
                                  <div className="flex items-center gap-2 mb-2">
                                    <input
                                      type="checkbox"
                                      className="w-4 h-4 text-[#9e68ba]"
                                      checked={addedhide}
                                      onChange={() => setAddedhide(!addedhide)}
                                    />
                                    <span className="text-sm font-medium text-gray-700">
                                      {t("delevery.modal.active_label")}
                                    </span>
                                  </div>
                                  <div className="space-y-2">
                                    <input
                                      type="text"
                                      placeholder={t(
                                        "delevery.modal.pickup_office_placeholder"
                                      )}
                                      className="w-full p-2 border border-gray-300 rounded-md focus:ring-purple-200 focus:border-purple-500"
                                      value={addedstopdesk}
                                      onChange={(e) =>
                                        setAddedstopdesk(e.target.value)
                                      }
                                      required
                                    />
                                    <input
                                      type="number"
                                      placeholder={t(
                                        "delevery.modal.pickup_price_placeholder"
                                      )}
                                      className="w-full p-2 border border-gray-300 rounded-md focus:ring-purple-200 focus:border-purple-500"
                                      value={addedpricestopdesk}
                                      onChange={(e) =>
                                        setAddedpricestopdesk(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="flex gap-2 justify-end p-4 border-t border-gray-200">
                                <button
                                  type="button"
                                  onClick={() => setShowModal(false)}
                                  className="py-2 px-4 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
                                >
                                  {t("delevery.modal.cancel")}
                                </button>
                                <button
                                  type="submit"
                                  className="py-2 px-4 bg-[#9b59bf] text-white rounded-lg hover:bg-[#814a9f] flex items-center gap-1"
                                >
                                  <CheckCircle size={18} />
                                  {t("delevery.modal.confirm")}
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          <Transition appear show={openConfirm} as={Fragment}>
            <Dialog
              as="div"
              className="relative z-50"
              onClose={() => setOpenConfirm(false)}
            >
              {/* Fade background */}
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" />
              </Transition.Child>

              <div className="fixed inset-0 flex items-center justify-center p-4">
                {/* Scale + Fade modal */}
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-90"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-90"
                >
                  <Dialog.Panel
                    className="w-full max-w-md rounded-2xl bg-white dark:bg-[#1a1a1a]
                     p-6 shadow-xl border border-gray-200 dark:border-white/10"
                  >
                    <Dialog.Title className="text-xl font-bold text-[#9b59bf] text-center mb-2">
                      {confirmType === "DHD"
                        ? t("ui.applyDhdRates")
                        : t("ui.applyZrRates")}
                    </Dialog.Title>

                    <p className="text-center text-gray-700 dark:text-gray-300 mb-6 leading-relaxed">
                      {t("ui.applyRatesPrompt")}{" "}
                      <strong>{confirmType}</strong>
                      {t("ui.applyRatesSuffix")}
                    </p>

                    <div className="flex items-center justify-center gap-3 mt-4">
                      <button
                        onClick={() => setOpenConfirm(false)}
                        className="px-5 py-2 rounded-lg border border-gray-300 dark:border-gray-600
                         text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700
                         transition"
                      >
                        {t("annule")}
                      </button>

                      <button
                        onClick={handleConfirmApply}
                        className="px-6 py-2 rounded-lg bg-[#9b59bf] hover:bg-[#814a9f]
                         text-white font-semibold shadow-lg shadow-purple-300/20
                         transition"
                      >
                        {t("ui.applyRates")}
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </Dialog>
          </Transition>

          <Footer />
        </div>
      </div>
      <Modal
        isOpen={isStopdeskModalOpen}
        onRequestClose={closeStopdeskModal}
        // التغيير هنا 👇
        className="max-w-2xl w-[95%] mx-auto mt-24 outline-none  rounded-lg bg-white"
        overlayClassName="fixed inset-0 bg-black/40 flex justify-center items-start z-[9999] overflow-y-auto"
       >
        <div className="bg-white dark:!bg-[#181819] rounded-2xl shadow-xl border border-[#fbf4ff] dark:!border-[#3c3a3d] p-5">
          {/* Header */}
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold text-gray-800 dark:!text-gray-100">
              {t("delevery.manage_stopdesk") ||
                t("delevery.manage_stopdesk")}
            </h2>
            <button
              type="button"
              onClick={closeStopdeskModal}
              className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-[#141414]"
            >
              <X className="text-gray-600 dark:!text-gray-300" />
            </button>
          </div>

          <div className="flex flex-col md:flex-row md:items-center gap-3 mb-4 p-3 rounded-xl bg-[#fcf6ff] dark:!bg-[#141414]">
            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                className="w-4 h-4 text-[#9e68ba] bg-gray-100 dark:!bg-[#3c3a3d] border-gray-300 dark:!border-[#3c3a3d] rounded focus:ring-purple-200"
                checked={stopdeskUsePricesDraft}
                onChange={() => setStopdeskUsePricesDraft((v) => !v)}
              />
              <span className="text-gray-800 dark:!text-gray-200 font-medium flex items-center gap-2">
                <DollarSign size={18} className="text-[#9e68ba]" />
                {t("delevery.stopdesk_use_prices") ||
                  t("ui.carrierRatesEnabled")}
              </span>
            </div>

            {/* ✅ Prix global (uniquement quand OFF) */}
            {!stopdeskUsePricesDraft && (
              <div className="flex items-center gap-2 md:ml-auto w-full md:w-auto">
                <span className="text-sm font-medium text-gray-700 dark:!text-gray-300">
                  {t("delevery.global_pickup_price") || t("ui.globalPrice")}
                </span>
                <input
                  type="number"
                  value={stopdeskGlobalPriceDraft}
                  onChange={(e) => setStopdeskGlobalPriceDraft(e.target.value)}
                  className="w-full md:w-40 p-2 border border-gray-300 dark:!border-[#3c3a3d] dark:!bg-[#181819] dark:!text-gray-200 rounded-md"
                  placeholder={t("ui.priceExample")}
                />
              </div>
            )}
          </div>

          {/* Rows */}
          <div className="space-y-3">
            {stopdeskDraft.map((row, idx) => (
              <div
                key={idx}
                className="grid grid-cols-1 md:grid-cols-12 gap-3 p-3 rounded-xl border border-gray-200 dark:!border-[#3c3a3d] bg-white dark:!bg-[#141414]"
              >
                {/* Company */}
                <div
                  className={`${stopdeskUsePricesDraft ? "md:col-span-7" : "md:col-span-11"
                    }`}
                >
                  <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300 mb-1">
                    {t("delevery.company_name") || t("ui.companyOffice")}
                  </label>
                  <input
                    type="text"
                    value={row.name}
                    onChange={(e) =>
                      updateStopdeskRow(idx, "name", e.target.value)
                    }
                    className="w-full p-2 border border-gray-300 dark:!border-[#3c3a3d] dark:!bg-[#181819] dark:!text-gray-200 rounded-md"
                    placeholder={
                      t("delevery.company_placeholder") || t("ui.yalidineExample")
                    }
                  />
                </div>

                {/* Price */}
                {stopdeskUsePricesDraft && (
                  <div className="md:col-span-4">
                    <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300 mb-1">
                      {t("delevery.company_price") || t("services.price")}
                    </label>
                    <input
                      type="number"
                      value={row.price}
                      onChange={(e) =>
                        updateStopdeskRow(idx, "price", e.target.value)
                      }
                      className="w-full p-2 border border-gray-300 dark:!border-[#3c3a3d] dark:!bg-[#181819] dark:!text-gray-200 rounded-md"
                      placeholder={t("ui.priceExample")}
                    />
                  </div>
                )}

                {/* Remove */}
                <div className="md:col-span-1 flex md:items-end">
                  <button
                    type="button"
                    onClick={() => removeStopdeskRow(idx)}
                    className="w-full md:w-auto p-2 rounded-lg border border-red-200 text-red-600 hover:bg-red-50 dark:hover:bg-[#181819]"
                    title={t("ship.delete")}
                  >
                    <Trash2 size={18} />
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Actions */}
          <div className="flex flex-col md:flex-row gap-3 mt-5">
            <button
              type="button"
              onClick={addStopdeskRow}
              className="py-2 px-4 rounded-lg border border-[#9b59bf] text-[#9b59bf] hover:bg-[#9b59bf] hover:text-white font-medium flex items-center justify-center gap-2"
            >
              <Plus size={18} />
              {t("delevery.add_company") || t("delevery.add_company")}
            </button>

            <div className="flex-1" />

            <button
              type="button"
              onClick={closeStopdeskModal}
              className="py-2 px-4 rounded-lg border border-gray-300 dark:!border-[#3c3a3d] text-gray-700 dark:!text-gray-200 hover:bg-gray-50 dark:hover:bg-[#141414]"
            >
              {t("common.cancel") || t("annule")}
            </button>

            <button
              type="button"
              onClick={saveStopdeskModal}
              className="py-2 px-4 rounded-lg bg-[#9b59bf] hover:bg-[#814a9f] text-white font-medium"
            >
              {t("common.save") || t("common.save")}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Delivery;
